/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Recentactivity_Serveralertresolved3Inputs */

const he_dashboard_recentactivity_serveralertresolved3 = /** @type {(inputs: Dashboard_Recentactivity_Serveralertresolved3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התראת שרת טופלה`)
};

const en_dashboard_recentactivity_serveralertresolved3 = /** @type {(inputs: Dashboard_Recentactivity_Serveralertresolved3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Server alert resolved`)
};

/**
* | output |
* | --- |
* | "Server alert resolved" |
*
* @param {Dashboard_Recentactivity_Serveralertresolved3Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const dashboard_recentactivity_serveralertresolved3 = /** @type {((inputs?: Dashboard_Recentactivity_Serveralertresolved3Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Recentactivity_Serveralertresolved3Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_dashboard_recentactivity_serveralertresolved3(inputs)
	return en_dashboard_recentactivity_serveralertresolved3(inputs)
});
export { dashboard_recentactivity_serveralertresolved3 as "dashboard_recentActivity_serverAlertResolved" }